// extracted by mini-css-extract-plugin
export default {"section":"HandClassificationLayersSection_section__9iovh","title":"HandClassificationLayersSection_title__MaswO","container":"HandClassificationLayersSection_container__eiWLT"};